// Libs
import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Hooks
import { useLocalStorage } from '@app/hooks/useLocalStorage';

// Classes
import { Dates } from '@app/classes/Dates';

// Constants
import { LOCAL_LANGUAGE } from '@app/constants/localStorage';

export const useLanguage = () => {
  const [localLanguage, setLocalLanguage] = useLocalStorage(LOCAL_LANGUAGE);
  const { i18n } = useTranslation();

  const handleChangeLanguage = useCallback(
    async (locale) => {
      Dates.setLocale(locale);
      setLocalLanguage(locale);
      await i18n.changeLanguage(locale);
    },
    [i18n]
  );

  useEffect(() => {
    localLanguage && handleChangeLanguage(localLanguage);
  }, [handleChangeLanguage, localLanguage]);

  return useMemo(
    () => ({ language: i18n.language, setLanguage: handleChangeLanguage }),
    [handleChangeLanguage, i18n.language]
  );
};
